import React from "react";

const Input = ({ name, label, error, type, comment, helpText, ...rest }) => {
  const togglePasswordVisibility = (e) => {
    const button = e.currentTarget;
    const input = button.closest('.input-group').querySelector('input');
    const icon = button.querySelector('i');

    if (input && icon) {
      if (input.type === "password") {
        input.type = "text";
        icon.className = "fa fa-eye-slash";
        button.title = "Hide password";
      } else {
        input.type = "password";
        icon.className = "fa fa-eye";
        button.title = "Show password";
      }
    }
  };
  
  return (
    <div className="form-group">
      <div className="row">
        <label htmlFor={name} className="col-sm-3 col-form-label col-form-label-sm text-sm-right pe-3 text-muted">{label}:</label>
        <div className="col-sm-8">
          <div className={type === "password" ? "input-group input-group-sm position-relative" : ""}>
            <input
              {...rest}
              name={name}
              id={name}
              type={type}
              className="form-control form-control-sm"
              placeholder={label}
            />
            {type === "password" && (
              <button 
                className="form-control-sm btn btn-sm"
                type="button"
                onClick={togglePasswordVisibility}
                title="Show password"
                style={{
                  width: '30px',
                  border: 'none',
                  borderRadius: '0.2rem',
                  position: 'absolute',
                  right: '3px',
                  top: '0px',
                  bottom: '0px',
                  boxShadow: 'none',
                  background: 'transparent',
                  zIndex: 100,
                }}
              >
                <i className="fa fa-eye" />
              </button>
            )}
          </div>
          {(comment || helpText) && (
            <small className="form-text text-muted">{comment || helpText}</small>
          )}
          {error && <div className="alert alert-danger small p-0" role="alert">{error}</div>}
        </div>
      </div>
    </div>
  );
};

export default Input;
